import React from 'react'
import {connect} from 'react-redux'

import {UI_SELECTOR} from '../shared/config/constants'

import unsetNewMessageIndicatorOnMobile from '../shared/data/actions/unset_new_message_indicator_on_mobile'
import setChatListToggled from '../shared/data/actions/set_chat_list_toggled'

import ChatListHeader from './chat_list_header.js'
import ChatCurrentUserBar from '../shared/chat_current_user_bar'
import ChatList from './chat_list.js'
import ConversationsStack from './conversations_stack.js'
import ModalDirector from '../shared/modal_director'
import ReportModal from '../shared/report_modal'
import UserProfileModal from '../shared/user_profile_modal'
import SessionInitiateModal from '../shared/session_initiate_modal'
import SessionRequestModal from '../shared/session_request_modal'
import GroupChatsModal from '../shared/group_chats_modal'
import GroupChatSubscriptionModal from '../shared/group_chat_subscription_modal'

class ChatUIPhone extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.modalsList = {
      report: ReportModal,
      userProfile: UserProfileModal,
      sessionInitiate: SessionInitiateModal,
      sessionRequest: SessionRequestModal,
      groupChats: GroupChatsModal,
      groupSubscribe: GroupChatSubscriptionModal
    }

    this.toggle = this.toggle.bind(this)
  }

  componentWillMount () {
    if (this.props.isToggled) {
      this.togglePageContent(true)
      this.props.removeNewMessageMobileIndicator()
    }

    if (!this.props.isToggled) {
      this.togglePageContent(false)
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.isToggled && this.props.isToggled) {
      this.togglePageContent(true)
      this.props.removeNewMessageMobileIndicator()
    }

    if (prevProps.isToggled && !this.props.isToggled) {
      this.togglePageContent(false)
    }
  }

  togglePageContent (determiner) {
    let displayStyle = determiner ? 'none' : ''
    let el = document.querySelector(UI_SELECTOR)
    let siblings = document.querySelectorAll('body > *')

    if (siblings && siblings.length > 0) {
      for (let i = 0; i < siblings.length; i++) {
        if (siblings[i] != el && siblings[i].nodeType == 1) {
          siblings[i].style.display = displayStyle
        }
      }
    }
  }

  toggle () {
    if (this.props.isMobilePage) return false
    const toggled = !this.props.isToggled
    this.props.setChatListToToggled(toggled)
  }


  renderInnerContent () {
    if (this.props.isMobilePage) {
      if (this.props.stack && this.props.stack.size > 0) {
        return (
          <div className='chat-ui-phone-wrapper'>
            <ConversationsStack {...this.props} phoneView={true}/>
          </div>
        )

      }
      else {
        return (
          <div className='chat-ui-phone-wrapper'>
            <ChatListHeader {...this.props} isMinimized={false} shouldShowMinimizeIndicator={false}/>
            <ChatCurrentUserBar/>
            <ChatList {...this.props}/>
          </div>
        )
      }
    }
    else {
      return (
        <div className='chat-ui-phone-wrapper minified'>
          <a href={this.props.mobilePageUrl} target='_blank'>
            <ChatListHeader
              shouldShowUnreadMessageIndicator={false}
              isMinimized={true}
              {...this.props}/>
          </a>
        </div>
      )

    }
  }

  renderModalView () {
    return <ModalDirector modalsList={this.modalsList}/>
  }

  render () {
    const height = this.props.isMobilePage ? '100%' : 'auto'
    return (
      <div className='chat-ui-phone' style={{height}}>
        {this.renderInnerContent()}
        {this.renderModalView()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stack: state.getIn(['conversations', '_stack', 'visibles']),
    isToggled: state.getIn(['chatListState', 'isToggled'], false),
    isMobilePage: state.getIn(['pluginSettings', 'isMobilePage'], false),
    mobilePageUrl: state.getIn(['pluginSettings', 'mobilePageUrl'])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeNewMessageMobileIndicator: () => dispatch(unsetNewMessageIndicatorOnMobile()),
    setChatListToToggled: (toggled) => dispatch(setChatListToggled(toggled))
  }
}

const ChatUIPhoneContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ChatUIPhone)

export default ChatUIPhoneContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_ui.phone.js
 **/